import React, { useCallback, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { useDispatch, useSelector } from "react-redux";
import Header from '../../Components/Header/Header';
import HeaderLower from '../../Components/HeaderLower/HeaderLower';
import FeaturedProduct from '../../Components/FeaturedProduct/FeaturedProduct';
import UnifiedCheckout from './UnifiedCheckout';
import { getMoneyChange } from '../../redux/actions';

export const getCarritoInvitado = async (productos) => {
  try {
    const res = await axios.post(
      'https://43a8phnwnh.execute-api.us-east-1.amazonaws.com/prod/get-producto/invitado',
      {
        httpMethod: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ productos, area: 4704 }),
        isBase64Encoded: false,
      }
    );
    return JSON.parse(res.data.body);
  } catch (e) {
    console.error(e);
    return [];
  }
};
export const getCarrito = async (token) => {
  try {
    const res = await axios.post(
      'https://dk8qbwpywj.execute-api.us-east-1.amazonaws.com/prod/conseguir-carrito',
      {
        httpMethod: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, fk_idarea: 4704 }),
        isBase64Encoded: false,
      }
    );
    return JSON.parse(res.data.body);
  } catch (e) {
    console.error(e);
    return [];
  }
};

const CarritoPage = () => {
  const { search } = useLocation();
  const params   = new URLSearchParams(search);
  const idpedido = params.get('idpedido');
  const token    = localStorage.getItem('token');
  const invStore = localStorage.getItem('carrito-sce-product-manager');
  const invProd  = invStore ? JSON.parse(invStore) : [];
  const precioDolar = useSelector((state) => state.dolarPrice);
  const dispatch = useDispatch();

  const [carrito, setCarrito]                 = useState([]);
  const [subTotal, setSubTotal]               = useState(0);
  const [total, setTotal]                     = useState(0);
  const [precioEnvio, setPrecioEnvio]         = useState(0);

  const [precioTotalDescuento, setPrecioTotalDescuento]           = useState(0);
  const [precioTotal, setPrecioTotal]                 = useState(0);
  const [precioTotalCupon, setPrecioTotalCupon]                   = useState(0);
  const [precioTotalCuponConOferta, setPrecioTotalCuponConOferta] = useState(0);
  const [precioTotalOferta, setPrecioTotalOferta]                 = useState(0);
  const [precioCuponRestante, setPrecioCuponRestante]             = useState(0);
  const [diferencialConPorcentaje, setDiferencialConPorcentaje]   = useState(0);
  const cuponProductos  = [];
  const medioPago       = '1';

  const loadInvitado = () => {
    const invStore = localStorage.getItem('carrito-sce-product-manager')
    const invProd  = invStore ? JSON.parse(invStore) : []
    getCarritoInvitado(invProd).then(arr => {
      if (!arr.length && !idpedido) {
        window.location.href = '/shop';
        return;
      }
      setCarrito(arr)
    })
  }

  const calcularPrecios = (arr) => {
    const pd = precioDolar;

    const tDes = arr.reduce((p, c) => {
      const usd    = c.precio_dolar          * pd;
      const usdOff = c.precio_oferta_dolares * pd;
      const pct    = Number(c.porcentaje_promo) || 0;
      const qty    = Number(c.cantidad_promo)   || 0;
      const base   = pct    ? usd    * (1 - pct/100)
                   : qty    ? usd    - qty
                   : usd;
      const baseOff= pct    ? usdOff * (1 - pct/100)
                   : qty    ? usdOff - qty
                   : usdOff;
      const d1     = base    * 0.8 * c.cantidad;
      const d2     = baseOff * 0.8 * c.cantidad;
      return p + (c.precio_oferta_dolares !== 0 ? Math.round(d2) : Math.round(d1));
    }, 0);

    const tS = arr.reduce((p, c) => {
      const usd = c.precio_dolar * pd;
      const pct = Number(c.porcentaje_promo) || 0;
      const qty = Number(c.cantidad_promo)   || 0;
      const base= pct    ? usd * (1 - pct/100)
                : qty    ? usd - qty
                : usd;
      return p + Math.round(base * c.cantidad);
    }, 0);

    const tC = arr.reduce((p, c) => {
      const cup = cuponProductos.find(x => x.idproducto == c.idproducto);
      if (!cup) return p + Math.round(c.precio_dolar * pd * c.cantidad);
      const val = c.precio_dolar * pd * (1 - cup.descuento/100) * c.cantidad;
      return p + Math.round(val);
    }, 0);

    const tCo = arr.reduce((p, c) => {
      const cup = cuponProductos.find(x => x.idproducto == c.idproducto);
      const usdOff = c.precio_oferta_dolares * pd;
      if (!cup) return p + Math.round(usdOff * c.cantidad);
      const val = usdOff * (1 - cup.descuento/100) * c.cantidad;
      return p + Math.round(val);
    }, 0);

    const tO = arr.reduce((p, c) => {
      const usd    = c.precio_dolar          * pd;
      const usdOff = c.precio_oferta_dolares * pd;
      const val    = (c.precio_oferta_dolares !== 0 ? usdOff : usd) * c.cantidad;
      return p + Math.round(val);
    }, 0);

    const cR = medioPago === '1'
      ? tCo - tDes
      : tS  - tC;
    
    const dP = tDes - tS;

    setPrecioTotalDescuento(tDes);
    setPrecioTotal(tS);
    setPrecioTotalCupon(tC);
    setPrecioTotalCuponConOferta(tCo);
    setPrecioTotalOferta(tO);
    setPrecioCuponRestante(cR);
    setDiferencialConPorcentaje(dP);
  }

  const loadCarritoYCalcula = useCallback(async () => {
    const response = await axios.get(`https://5fmuobow2m.execute-api.us-east-1.amazonaws.com/prod/get-datos-moneda`)
    const precioArray = JSON.parse(response.data.body);
    const precioDolar = precioArray[0].importeARS;
    let arr = [];
    if (token) {
      arr = await getCarrito(token);
    } else {
      arr = await getCarritoInvitado(invProd);
    }
    if (!arr.length && !idpedido) {
      window.location.href = '/shop';
      return;
    }
    console.log(arr);
    setCarrito(arr);

    const sub = arr.reduce(
      (s, c) => s + c.cantidad * (c.precio_oferta || c.precio_pesos),
      0
    );
    setSubTotal(sub);
    setTotal(sub - 0);
    calcularPrecios(arr);
  }, []);

  useEffect(() => {
    loadCarritoYCalcula();
  }, []);

  useEffect(() => {
    const handler = () => loadCarritoYCalcula();
    window.addEventListener('cartUpdated', handler);
    return () => window.removeEventListener('cartUpdated', handler);
  }, []);

  useEffect(() => {
    loadCarritoYCalcula();
  }, []);

  useEffect(() => {
    if (token) {
      getCarrito(token).then(arr => {
        if (!arr.length && !idpedido) {
          window.location.href = '/shop';
          return;
        }
        setCarrito(arr)
      })
    } else {
      loadInvitado()
    }
  }, []);

  const handleRemoveInvitado = (idproducto) => {
    const invStore = JSON.parse(localStorage.getItem('carrito-sce-product-manager')) || [];
    const updated = invStore.filter(p => p.idproducto != idproducto);
    localStorage.setItem('carrito-sce-product-manager', JSON.stringify(updated));
    window.dispatchEvent(new Event('cartUpdated'));
    loadInvitado();
  };

  useEffect(() => {
    if (carrito.length) {
      calcularPrecios(carrito);
    }
  }, [carrito, precioDolar, medioPago]);

  return (
    <>
      <UnifiedCheckout
        carrito={carrito}
        subTotal={subTotal}
        total={total}
        precioEnvio={precioEnvio}
        precioTotalDescuento={precioTotalDescuento}
        precioTotal={precioTotal}
        precioTotalCupon={precioTotalCupon}
        precioTotalCuponConOferta={precioTotalCuponConOferta}
        precioTotalOferta={precioTotalOferta}
        precioCuponRestante={precioCuponRestante}
        diferencialConPorcentaje={diferencialConPorcentaje}
        onRemoveInvitado={handleRemoveInvitado}
        precioDolar={precioDolar}
        setCarrito={setCarrito}
      />

      <FeaturedProduct />
    </>
  );
};

export default CarritoPage;
